<div class="side-panel">
  <div class="dialog-header">
    <h2>Detalles de la cita</h2>
    <button class="close-btn">×</button>
  </div>

  <div class="dialog-content">
    <div class="info-block">
      <p><span class="label">Cliente:</span> Víctor Gimeno Sanz</p>
      <p><span class="label">Servicio:</span> Corte + Barba Premium</p>
      <p><span class="label">Empleado:</span> Laura Rodríguez</p>
      <p><span class="label">Inicio:</span> 6 nov 2025, 10:00</p>
      <p><span class="label">Fin:</span> 6 nov 2025, 10:45</p>
      <p><span class="label">Notas:</span> Prefiere pago con tarjeta</p>
    </div>

    <hr />

    <div class="actions">
      <button class="btn btn-convfact">Crear ticket</button>
      <button class="btn danger">Borrar</button>
      <button class="btn secondary">Cerrar</button>
    </div>
  </div>
</div>



<!-- <div class="dialog-header">
  <h2>Detalles de la cita</h2>
</div>

<ng-container *ngIf="working === false">
  <mat-dialog-content>
    <p><strong>Cliente:</strong> {{ clientName }}</p>
    <p><strong>Servicio:</strong> {{ concept.name }}</p>
    <p><strong>Empleado:</strong> {{ employeeName }}</p>
    <p><strong>Inicio:</strong> {{ data.appointment.startTime | date:'short' }}</p>
    <p><strong>Fin:</strong> {{ data.appointment.endTime | date:'short' }}</p>
    <p><strong>Notas:</strong> {{ data.appointment.notes || 'Sin notas' }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" class="ticket-btn me-2" (click)="createTicket()">Crear
      ticket</button>
    <button mat-flat-button class="ticket-btn-delete" (click)="delete()">Borrar</button>
    <button mat-stroked-button mat-dialog-close class="ms-2">Cerrar</button>
  </mat-dialog-actions>
</ng-container>
<ng-container *ngIf="working">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container> -->